import React from "react";
import { ITranslationKeys } from "@components/i18n/keys";
import { NoServiceTab } from "./noService";
import { PoorNoSignalTab } from "./poorNoSignal";
import { CoverageTab } from "./coverage";

export interface ITabMap {
  tab: React.FC,
  title: keyof ITranslationKeys['maps']
}

export const useTabsMap = () => {
  const tabsMap: ITabMap[] = React.useMemo(() => {
    const shownTabs: ITabMap[] = [
      { title: 'NO_SERVICE_TAB', tab: NoServiceTab },
      { title: 'VERY_POOR_NO_SERVICE_TAB', tab: PoorNoSignalTab },
      { title: 'COVERAGE_TAB', tab: CoverageTab },
    ];

    return shownTabs;
  }, []);

  return tabsMap;
};

export const getMapIdFromTabTitle = (tabTitle: string) => {
  // remove trailing '_TAB'
  return tabTitle.slice(0, -4);
};
